
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-5b8079eb&scoped=true!stylus-loader?sourceMap!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./personal-info-card.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./personal-info-card.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-5b8079eb!../../node_modules/vue-loader/lib/selector?type=template&index=0!./personal-info-card.vue"),
  /* scopeId */
  "data-v-5b8079eb",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/comps/personal-info-card.vue
// module id = 765
// module chunks = 34